import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationData } from '../application.model';
import { ApplicationService } from '../application.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-application-app-bar-title',
    templateUrl: './application-app-bar-title.component.html',
    styleUrls: ['./application-app-bar-title.component.scss'],
    standalone: false
})
export class ApplicationAppBarTitleComponent implements OnInit {

  data: ApplicationAppBarTitleComponentData;
  title: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private applicationService: ApplicationService) { }

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe((it: ApplicationAppBarTitleComponentData) => {
        this.data = it;
        this.title = (this.data.application.entityName || "") + ' - ' + (this.data.application.applicationNumber || "");
      });
  }

  applicationListNavigate() {
    this.router.navigateByUrl(this.applicationService.prevApplicationListUrl || '/application');
  }

}

export interface ApplicationAppBarTitleComponentData {
  application: ApplicationData;
}
